import { call, put, takeEvery, all, select } from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getEntityCall } from '../../baseApp/entities/sagas';
import DateTimeUtils from '../../baseApp/shared/utils/DateTimeUtils';
import { getUserPageRefresh } from '../../baseApp/auth/sagas';

const controllerUrl = '/consoleUsers/';

const searchConsoleUsersCall = searchFields => new Promise((resolve, reject) => {

        axios.get(controllerUrl + 'search', {
            params: {
                ...searchFields,
            }
        }).then(
            response => resolve(response.data),
            error => reject(error)
        );
});

const getConsoleUserCall = (id) => new Promise((resolve, reject) => {
    axios.get(controllerUrl + id).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const createConsoleUserCall = consoleUserData => new Promise((resolve, reject) => {
    axios.post(controllerUrl, consoleUserData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const editConsoleUserCall = (consoleUserId, consoleUserData) => new Promise((resolve, reject) => {
    axios.put(controllerUrl + consoleUserId, consoleUserData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const deleteConsoleUserCall = consoleUserId => new Promise((resolve, reject) => {
    axios.delete(controllerUrl + consoleUserId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

function* searchConsoleUsersRequest({ searchFields }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const searchResults = yield call(searchConsoleUsersCall, searchFields);
        const entityIds = searchResults.content.map(consoleUser => consoleUser.entityId);

        const uniqueEntityIds = [...new Set(entityIds)];
        const entities = yield all(uniqueEntityIds.map(id => call(getEntityCall, id)));

        const searchResultsWithEntities = {
            ...searchResults,
            content: searchResults.content.map(
                consoleUser => ({
                    ...consoleUser,
                    entity: entities.find(e => e.id === consoleUser.entityId),
                    lastCommunication: consoleUser.lastCommunicationTimestamp? DateTimeUtils.getDateTimeFromUnix(consoleUser.lastCommunicationTimestamp) : '- - -'
                })
            )
        };
        yield put({
            type: actionTypes.CONSOLE_USER_SEARCH_SUCCESS,
            payload: searchResultsWithEntities
        });
    } catch (e) {
        yield put({
            type: actionTypes.CONSOLE_USER_SEARCH_FAILED,
            payload: e
        });
    }
}

function* getConsoleUserRequest({ consoleUserId }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const consoleUser = yield call(getConsoleUserCall, consoleUserId);

        consoleUser.entity = consoleUser.entityId;
        consoleUser.lastCommunication = consoleUser.lastCommunicationTimestamp? DateTimeUtils.getDateTimeFromUnix(consoleUser.lastCommunicationTimestamp) : '- - -';

        yield put({
            type: actionTypes.GET_CONSOLE_USER_SUCCESS,
            payload: consoleUser
        });
    } catch (e) {
    }
}

function* createConsoleUserRequest({ consoleUserData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const consoleUserFormData = {
            ...consoleUserData,
            entityId: consoleUserData.entity
        };

        yield call(createConsoleUserCall, consoleUserFormData);

        yield put({
            type: actionTypes.CREATE_CONSOLE_USER_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.CREATE_CONSOLE_USER_FAILED
        })
    }
}

function* editConsoleUserRequest({ consoleUserId, consoleUserData }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const consoleUserFormData = {
            ...consoleUserData,
            entityId: consoleUserData.entity
        };

        yield call(editConsoleUserCall, consoleUserId, consoleUserFormData);

        yield put({
            type: actionTypes.EDIT_CONSOLE_USER_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.EDIT_CONSOLE_USER_FAILED
        })
    }
}

function* deleteConsoleUserRequest({ consoleUserId }) {
    try {
        yield call(deleteConsoleUserCall, consoleUserId);

        yield put({
            type: actionTypes.DELETE_CONSOLE_USER_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.DELETE_CONSOLE_USER_FAILED
        })
    }
}

const consoleUsersSagas = [
    takeEvery(actionTypes.CONSOLE_USER_SEARCH_REQUEST, searchConsoleUsersRequest),
    takeEvery(actionTypes.GET_CONSOLE_USER_REQUEST, getConsoleUserRequest),
    takeEvery(actionTypes.CREATE_CONSOLE_USER_REQUEST, createConsoleUserRequest),
    takeEvery(actionTypes.EDIT_CONSOLE_USER_REQUEST, editConsoleUserRequest),
    takeEvery(actionTypes.DELETE_CONSOLE_USER_REQUEST, deleteConsoleUserRequest),
];

export {
    consoleUsersSagas,
    getConsoleUserCall
};